import { createPinia, type PiniaPluginContext } from 'pinia'

export const install = (app: any) => {
  const pinia = createPinia()
  app.use(pinia)
}

const hydratedStores = new Set<string>()
export function hydrationTrackerPlugin({ store }: PiniaPluginContext) {
  // Wait until next tick to mark the store as hydrated
  // This assumes that persisted state has been loaded by then
  if (!hydratedStores.has(store.$id)) {
    setTimeout(() => {
      if ('hydrated' in store) {
        store.hydrated = true
      }
      hydratedStores.add(store.$id)
    }, 0)
  }
}
